import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { STATUSES, ORDER_STATUSES } from '@hobs/utils/constants';
import Styles from './Status.module.scss';

const Status = ({
  name,
  type = 0,
  statuses,
  order = false,
  inverted = false
}) => {
  if (!statuses) {
    statuses = order ? ORDER_STATUSES : STATUSES;
  }

  const color = statuses[isNaN(type) ? 0 : type].color;

  return (
    <div
      className={cx(Styles.status, {
        inverted: inverted
      })}
      title={name}
      style={
        inverted
          ? {
              color: color,
              borderColor: color,
              border: '1px solid ' + color
            }
          : {
              backgroundColor: color
            }
      }
    >
      {name}
    </div>
  );
};

Status.propTypes = {
  order: PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.number,
  statuses: PropTypes.object,
  inverted: PropTypes.bool
};

export default Status;
